import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import { InjectorService, ToolbarService } from '@tencent/workbench';

export default class BaseSelectablePanelFeature extends BaseToolbarFeature {
    public toolbarService: ToolbarService;
    public constructor() {
        super();
        this.toolbarService = InjectorService.get(ToolbarService);
    }
}
